import {
  TARGET_TAB,
  SEARCH_TARGET_CONDITION,
  CONDITION_RADIO,
  TARGET_LIST_CATEGORY,
  INDUSTRY_FLG,
  GET_MASTER_FLG,
  LATEST_FLG,
  PATTERN_MATCH,
} from '../../common/const';
import {
  SET_TAB,
  SET_DOWNLOAD_STATUS,
  SET_POLLING_ID,
  SET_SEARCH_CONDITION,
  SET_DISP_SEARCH_CONDITION,
  SET_COMPANY_SEARCH_LIST,
  SET_INIT_TARGET_STATE,
  SET_AREA,
  SET_PREF_LIST,
  SET_INDUSTRY_B,
  SET_INDUSTRY_N,
  SET_INDUSTRY_S,
  SET_INDUSTRY_M,
  SET_TRADE_INFO_SEARCH_ITEM_LIST,
  SET_TARGET_LIST_HEADER_ITEM,
  SET_TARGET_LIST_HEADER_WIDTH,
  SET_TARGET_LIST_CATEGORY,
  SET_SAVE_CONDITON_POP_FLG,
  SET_SAVE_CONDITON_SUCCESS_POP_FLG,
  SET_SEARCH_CONDITON_POP_FLG,
  SET_SEARCH_CONDITON_DELETE_POP_FLG,
  SET_ALERT_MASTER_POP_FLG,
  SET_ADDRESS_POP_FLG,
  SET_INDUSTRY_POP_FLG,
  SET_PRODUCTS_POP_FLG,
  SET_COMPANY_POP_FLG,
  SET_COMPANY_POP_BTN,
  SET_COMPANY_DUNS_KEYWORD,
  SET_COMPANY_TSR_KEYWORD,
  SET_COMPANY_NAME_KEYWORD,
  SET_COMPANY_HOJIN_KEYWORD,
  SET_COMPANY_NAME_SEARCH_TYPE,
  SET_TRADE_INFO_POP_FLG,
  SET_DOWNLOAD_REQUEST_POP_FLG,
  SET_DOWNLOAD_CONFIG,
  SET_NOWPAGE,
  SET_SEARCH_CONDITON_SEQ_ID,
  SET_SEARCH_TARGET,
  SET_SELECT_AREA,
  SET_SELECT_PREF,
  SET_ADDRESS_CONDITION,
  SET_SELECT_INDUSTRY_B,
  SET_SELECT_INDUSTRY_N,
  SET_SELECT_INDUSTRY_S,
  SET_SELECT_INDUSTRY_M,
  SET_INDUSTRY_CONDITION,
  SET_INDUSTRY_ADD_CONDITION,
  SET_INDUSTRY_DISPLAY_CONDITION,
  SET_PRODUCT_DISPLAY_CONDITION,
  SET_INDUSTRY_RESULT,
  SET_INDUSTRY_KEYWORD,
  SET_PRODUCTS_CONDITION,
  SET_MAIN_INDUSTRY_FLG,
  SET_TRADE_INFO_SEARCH_ITEM,
  SET_TRADE_INFO_CONDITION,
  SET_ACCOUNT_MONTH,
  SET_CAPITAL_FROM,
  SET_CAPITAL_TO,
  SET_SALES_FROM,
  SET_SALES_TO,
  SET_LATEST_FLG,
  SET_SALES_RATE_FROM,
  SET_SALES_RATE_TO,
  SET_BENEFIT_FROM,
  SET_BENEFIT_TO,
  SET_BENEFIT_RATE_FROM,
  SET_BENEFIT_RATE_TO,
  SET_EMPLOYEE_FROM,
  SET_EMPLOYEE_TO,
  SET_TOP_DUNS,
  SET_TOP_TSR_CODE,
  SET_SCORE_FROM,
  SET_SCORE_TO,
  SET_OFFICE_COUNT_FROM,
  SET_OFFICE_COUNT_TO,
  SET_REP_LAST_NAME,
  SET_REP_FIRST_NAME,
  SET_ADDITIONALITEM,
  SET_TRADE_SEARCH_FLAG1,
  SET_TRADE_SEARCH_FLAG2,
  SET_DISP_OFFICE_COUNT_FROM,
  SET_DISP_OFFICE_COUNT_TO,
  SET_DISP_CAPITAL_FROM,
  SET_DISP_CAPITAL_TO,
  SET_DISP_SALES_FROM,
  SET_DISP_SALES_TO,
  SET_DISP_SALES_RATE_FROM,
  SET_DISP_SALES_RATE_TO,
  SET_DISP_BENEFIT_FROM,
  SET_DISP_BENEFIT_TO,
  SET_DISP_BENEFIT_RATE_FROM,
  SET_DISP_BENEFIT_RATE_TO,
  SET_DISP_EMPLOYEES_FROM,
  SET_DISP_EMPLOYEES_TO,
  SET_ERR_MSG_CAPITAL,
  SET_ERR_MSG_SALES,
  SET_ERR_MSG_RATE,
  SET_ERR_MSG_BENEFIT,
  SET_ERR_MSG_BENEFIT_RATE,
  SET_ERR_MSG_EMPLOYEES,
  SET_ERR_MSG_TOP_DUNS,
  SET_ERR_MSG_TOP_TSR_CODE,
  SET_ERR_MSG_SCORE,
  SET_ERR_MSG_REP_NAME,
  SET_ERR_MSG_OFFICE_COUNT,
  SET_ERR_MSG_TRADE_INFO_SEARCH_VALUE,
  SET_ERR_MSG_INDUSTRY_KEYWORD,
  SET_ERR_MSG_INDUSTRY_DUPLICATE,
  SET_ERR_MSG_CONDITION_NAME,
  SET_CHECK_CAPITAL_FROM,
  SET_CHECK_CAPITAL_TO,
  SET_CHECK_SALES_FROM,
  SET_CHECK_SALES_TO,
  SET_CHECK_RATE_FROM,
  SET_CHECK_RATE_TO,
  SET_CHECK_BENEFIT_FROM,
  SET_CHECK_BENEFIT_TO,
  SET_CHECK_BENEFIT_RATE_FROM,
  SET_CHECK_BENEFIT_RATE_TO,
  SET_CHECK_EMPLOYEES_FROM,
  SET_CHECK_EMPLOYEES_TO,
  SET_CHECK_TOP_DUNS,
  SET_CHECK_TOP_TSR_CODE,
  SET_CHECK_SCORE_FROM,
  SET_CHECK_SCORE_TO,
  SET_CHECK_REP_LAST_NAME,
  SET_CHECK_REP_FIRST_NAME,
  SET_CHECK_TRADE_INFO_SEARCH_VALUE,
  SET_CHECK_OFFICE_COUNT_FROM,
  SET_CHECK_OFFICE_COUNT_TO,
  SET_CHECK_INDUSTRY_KEYWORD,
  SET_CHECK_CONDITION_NAME,
  SET_INIT_SEARCH_CONDITION,
  SET_LIMIT_MESSAGE,
  SET_PRODUCT_SEARCH_CONDITION,
  SET_BUSINESS_TYPE,
  SET_SELECT_BUSINESS_TYPE,
  SET_PRODUCT_RESULT_LIST,
  SET_PRODUCT_ADD_CONDITION,
  SET_ERR_MSG_PRODUCT_DUPLICATE,
  SET_ERR_MSG_PRODUCT_KEYWORD,
  SET_CHECK_PRODUCT_KEYWORD,
  SET_CONDITION_NAME,
  SET_DISP_CONDITION_NAME,
  SET_SAVE_CONDITION,
  SET_UPDATE_TARGETING_CRITERIA,
  SET_SELECT_CONDITION_FLG,
  SET_SEARCH_CONDITION_LIST,
  SET_IMPORT_FILE,
  SET_GET_ADDRESS_FLG,
  SET_GET_INDUSTRY_FLG,
  SET_GET_PRODUCT_FLG,
  SET_GET_CUSTOMER_COMPANY_FLG,
  SET_GET_SUPPLIER_COMPANY_FLG,
  SET_GET_TOP_COMPANY_FLG,
  SET_GET_TRADE_INFO_FLG,
  SET_ALERT_ITEM,
  SET_ERR_MSG_SEARCH_CONDITION_POP,
  SET_ERR_MSG_COMPANY_DUNS_KEYWORD,
  SET_ERR_MSG_COMPANY_TSR_KEYWORD,
  SET_ERR_MSG_COMPANY_NAME_KEYWORD,
  SET_ERR_MSG_COMPANY_HOJIN_KEYWORD,
  SET_ERR_MSG_COMPANY_DUPLICATE,
  SET_CHECK_COMPANY_DUNS_KEYWORD,
  SET_CHECK_COMPANY_TSR_KEYWORD,
  SET_CHECK_COMPANY_NAME_KEYWORD,
  SET_CHECK_COMPANY_HOJIN_KEYWORD,
  SET_COMPANY_RESULT,
  SET_CUSTOMER_COMPANY_CONDITION,
  SET_CUSTOMER_COMPANY_ADD_CONDITION,
  SET_CUSTOMER_COMPANY_DISPLAY_CONDITION,
  SET_SUPPLIER_COMPANY_CONDITION,
  SET_SUPPLIER_COMPANY_ADD_CONDITION,
  SET_SUPPLIER_COMPANY_DISPLAY_CONDITION,
  SET_TOP_COMPANY_CONDITION,
  SET_TOP_COMPANY_ADD_CONDITION,
  SET_TOP_COMPANY_DISPLAY_CONDITION,
  SET_SCORE_SLIDER,
  SET_CLASSIFICATION_LIST,
  SET_SGKN,
  SET_SGKN_SEARCH_TYPE,
  SET_START_YEAR_FROM,
  SET_START_MONTH_FROM,
  SET_START_YEAR_TO,
  SET_START_MONTH_TO,
  SET_MARKET_SEGMENT,
  SET_SYRK_GKNY,
  SET_MARKET_SEGMENT_LIST,
  SET_DISP_JGKB_LIST,
  SET_JGKB_LIST,
  SET_CHECK_SGKN,
  SET_CHECK_START_YEAR_FROM,
  SET_CHECK_START_MONTH_FROM,
  SET_CHECK_START_YEAR_TO,
  SET_CHECK_START_MONTH_TO,
  SET_CHECK_SYRK_GKNY,
  SET_ERR_MSG_SGKN,
  SET_ERR_MSG_START_YM,
  SET_ERR_MSG_SYRK_GKNY,
  SET_TRADE_INFO_ADD_CONDITION,
  SET_CHECK_TRADE_INFO_LIMIT,
  SET_ERR_MSG_TRADE_INFO_LIMIT,
  SET_ERR_MSG_TRADE_INFO_REQUIRED,
  SET_ADDRESS_KEYWORD,
  SET_ERR_MSG_ADDRESS_KEYWORD,
  SET_CHECK_ADDRESS_KEYWORD,
  SET_ADDRESS_RESULT,
  SET_ADDRESS_ADD_CONDITION,
  SET_ERR_MSG_ADDRESS_POP,
  SET_ADDRESS_DISPLAY_CONDITION,
  SET_TARGETING_DISP_ITEMS,
  SET_SEND_SALESFORCE_POP_FLG,
  SET_SEND_SALESFORCE_TARGET_NAME,
  SET_ERR_MSG_SALESFORCE_TARGET_NAME,
  SET_SALESFORCE_MAP_OBJECT,
  SET_SALESFORCE_MAP_OBJECT_NAME,
  SET_SALESFORCE_MAP_MODE_KBN,
  SET_SALESFORCE_MAP_COLUMN_NAME,
  SET_SALESFORCE_MAP_FIELD_LIST,
  SET_SALESFORCE_MAX_CHECK_COUNT,
  SET_EXTERNAL_MAX_CHECK_COUNT,
  SET_SEND_EXTERNAL_POP_FLG,
  SET_SEND_EXTERNAL_CONFIG,
  SET_SEND_EXTERNAL_TARGET_NAME,
  SET_SEND_EXTERNAL_RESULT_POP_FLG,
  SET_ERR_MSG_EXTERNAL_TARGET_NAME,
  SET_EXTERNAL_ERR_MSG,

} from '../actions/TargetAction';

// 検索タブ用検索条件(初期値)
const initDispSearchCondition = {
  // 検索対象
  searchTarget: SEARCH_TARGET_CONDITION.SEARCH_TARGET_ONE,
  // 選択済み地域
  selectArea: '',
  // 選択済み都道府県
  selectPref: '',
  // 所在地追加済み条件
  addressCondition: [],
  // 選択済み大分類
  selectIndustryB: [],
  // 選択済み中分類
  selectIndustryN: [],
  // 選択済み小分類
  selectIndustryS: [],
  // 選択済み細分類
  selectIndustryM: [],
  // 業種追加済み条件
  industryCondition: [],
  // 扱い品追加済み条件
  productsCondition: [],
  // 主業種フラグ
  mainIndustryFlg: INDUSTRY_FLG.INDUSTRY_ONE,
  // 取引条件項目
  tradeInfoSearchItem: '',
  // 取引情報追加済み条件
  tradeInfoCondition: [],
  // 最新決済月
  accountMonth: [],
  // 資本金
  capitalFrom: null,
  capitalTo: null,
  // 当期売上高
  salesFrom: null,
  salesTo: null,
  // 決算情報最新期フラグ
  latestFlg: LATEST_FLG.LATEST_OFF,
  // 当期売上伸長率
  salesRateFrom: null,
  salesRateTo: null,
  // 当期利益金
  benefitFrom: null,
  benefitTo: null,
  // 当期利益伸長率
  benefitRateFrom: null,
  benefitRateTo: null,
  // 従業員数
  employeeFrom: null,
  employeeTo: null,
  // 国内最上位親会社DUNS
  topDuns: null,
  // 国内最上位親会社TSRコード
  topTsrCode: null,
  // 評点
  scoreFrom: null,
  scoreTo: null,
  // 事業所数
  officeCountFrom: null,
  officeCountTo: null,
  // 代表者
  repLastName: null,
  repFirstName: null,
  // 取引情報有無
  additionalitem: CONDITION_RADIO.CONDITION_NONE,
  // 取引情報検索フラグ1
  tradesearchflag1: CONDITION_RADIO.CONDITION_NONE,
  // 取引情報検索フラグ2
  tradesearchflag2: CONDITION_RADIO.CONDITION_NONE,
  // 表示用資本金(3桁カンマ)
  dispCapitalFrom: null,
  dispCapitalTo: null,
  // 表示用売上高(3桁カンマ)
  dispSalesFrom: null,
  dispSalesTo: null,
  // 表示用売上高伸長率(3桁カンマ)
  dispSalesRateFrom: null,
  dispSalesRateTo: null,
  // 表示用利益金(3桁カンマ)
  dispBenefitFrom: null,
  dispBenefitTo: null,
  // 表示用利益金伸長率(3桁カンマ)
  dispBenefitRateFrom: null,
  dispBenefitRateTo: null,
  // 表示用従業員数(3桁カンマ)
  dispEmployeesFrom: null,
  dispEmployeesTo: null,
  // 表示用事業所数(3桁カンマ)
  dispOfficeCountFrom: null,
  dispOfficeCountTo: null,
  selectBusinessType: [],
  // 所在地取得フラグ設定
  getAddressFlg: GET_MASTER_FLG.OFF,
  // 業種取得フラグ設定
  getIndustryFlg: GET_MASTER_FLG.OFF,
  // 扱い品取得フラグ設定
  getProductFlg: GET_MASTER_FLG.OFF,
  // 事業所区分リスト
  jgkbList: [],
  // 上場市場
  marketSegment: [],
  // 評点（スライダー）
  scoreSlider: [0, 0],
  // 格付け
  classificationList: [],
  // 商号漢字
  sgkn: null,
  // 商号漢字検索タイプ区分
  sgknSearchType: PATTERN_MATCH.EXACT,
  // 設立年FROM
  startYearFrom: null,
  // 設立月FROM
  startMonthFrom: null,
  // 設立年TO
  startYearTo: null,
  // 設立月TO
  startMonthTo: null,
  // 概況
  syrkGkny: null,
  // 販売先追加済み条件
  customerCompanyCondition: null,
  // 仕入先追加済み条件
  supplierCompanyCondition: null,
  // 国内最上位親会社追加済み条件
  topCompanyCondition: null,
};

// 入力チェック用エラー情報
const initErrInfo = {
  // エラーメッセージ
  errMsgCapital: '',
  errMsgSales: '',
  errMsgRate: '',
  errMsgBenefit: '',
  errMsgBenefitRate: '',
  errMsgEmployees: '',
  errMsgTopDuns: '',
  errMsgTopTsrCode: '',
  errMsgScore: '',
  errMsgOfficeCount: '',
  errMsgRepName: '',
  errMsgTradeInfoSearchValue: '',
  errMsgSearchConditionPop: '',
  errMsgSgkn: '',
  errMsgStartYm: '',
  errMsgSyrkGkny: '',

  // エラーフラグ
  checkErrFlg: {
    checkCapitalFrom: false,
    checkCapitalTo: false,
    checkSalesFrom: false,
    checkSalesTo: false,
    checkRateFrom: false,
    checkRateTo: false,
    checkBenefitFrom: false,
    checkBenefitTo: false,
    checkBenefitRateFrom: false,
    checkBenefitRateTo: false,
    checkEmployeesTo: false,
    checkEmployeesFrom: false,
    checkTopDuns: false,
    checkTopTsrCode: false,
    checkScoreFrom: false,
    checkScoreTo: false,
    checkOfficeCountFrom: false,
    checkOfficeCountTo: false,
    checkRepLastName: false,
    checkRepFirstName: false,
    checkTradeInfoSearchValue: false,
    checkSgkn: false,
    checkStartYearFrom: false,
    checkStartMonthFrom: false,
    checkStartYearTo: false,
    checkStartMonthTo: false,
    checkSyrkGkny: false,
  },
};

const initState = {
  // 表示タブ
  tab: TARGET_TAB.TAB_SEARCH,
  // ダウンロードステータス
  downloadStatus: {},
  // ポーリングID
  pollingId: null,
  // リクエストパラメータ用検索条件
  searchCondition: null,
  saveCondition: null,
  // リストタブ表示用検索条件
  dispSearchCondition: {
    trade_list: [],
  },
  // 検索結果
  companySearchList: {},
  // 地域候補リスト
  areaList: null,
  // 都道府県候補リスト
  prefList: null,
  // 大分類候補リスト
  industryB: null,
  // 中分類候補リスト
  industryN: null,
  // 小分類候補リスト
  industryS: null,
  // 細分類候補リスト
  industryM: null,
  // 取引条件項目リスト
  tradeInfoSearchItem: [],
  // 結果項目リスト
  targetListHeaderItem: [],
  // 結果リスト横幅
  targetListHeaderWidth: 0,
  // ターゲット検索一覧のカテゴリ
  targetListCategory: TARGET_LIST_CATEGORY.KIGYO,
  // 検索条件保存ポップアップ表示フラグ
  saveConditionPopFlg: false,
  // 検索条件一覧ポップアップ表示フラグ
  searchConditionPopFlg: false,
  // マスタ存在アラートポップアップ表示フラグ
  alertMasterPopFlg: false,
  // 画面表示用アラート項目
  alertItem: null,
  // 所在地ポップアップ表示フラグ
  addressPopFlg: false,
  // 業種ポップアップ表示フラグ
  industryPopFlg: false,
  // 扱い品ポップアップ表示フラグ
  productsPopFlg: false,
  // 扱い品キーワード
  searchProductCondition: null,
  // 扱い品業態
  businessType: null,
  // 扱い品ポップアップ表示フラグ
  companyPopFlg: false,
  // 取引情報ポップアップ表示フラグ
  tradeInfoPopFlg: false,
  // ダウンロードステータスポップアップ表示フラグ
  downloadRequestPopFlg: false,
  // ダウンロード件数超過フラグ
  downloadLimitOverFlg: false,
  // ダウンロード件数超過メッセージ
  downloadLimitOverMessage: null,
  // ダウンロード条件
  downloadConfig: null,
  // 現在ページ番号
  nowpage: 1,
  // 検索タブ用検索条件
  ...initDispSearchCondition,
  // 入力チェック用エラー情報
  ...initErrInfo,
  // 件数上限メッセージ
  limitMessage: null,
  selectSearchCondArea: '',
  selectSearchCondPref: '',
  selectedGyotaiCode: null,
  productResultList: null,
  productsCondition: [],
  productAddCondition: [],
  tradeInfoAddCondition: [],
  // 検索条件名を初期化
  dispConditionName: null,
  // 外部連携ポップアップ表示フラグ
  sendExternalPopFlg: false,
  // Salesforce連携ポップアップ表示フラグ
  sendSalesforcePopFlg: false,
  // 外部連携関連設定値
  sendExternalResultOverPopFlg: false,
  sendExternalConfig: null,
  sendExternalTargetName: '',
  // Salesforce連携関連設定値
  sendSalesforceTargetName: '',

};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TAB:
      return { ...state, tab: action.tab };
    case SET_DOWNLOAD_STATUS:
      return { ...state, downloadStatus: action.downloadStatus };
    case SET_POLLING_ID:
      return { ...state, pollingId: action.pollingId };
    case SET_SEARCH_CONDITION:
      return { ...state, searchCondition: action.searchCondition };
    case SET_DISP_SEARCH_CONDITION:
      return { ...state, dispSearchCondition: action.dispSearchCondition };
    case SET_COMPANY_SEARCH_LIST:
      return { ...state, companySearchList: action.companySearchList };
    case SET_AREA:
      return { ...state, areaList: action.areaList };
    case SET_PREF_LIST:
      return { ...state, prefList: action.prefList };
    case SET_INDUSTRY_B:
      return { ...state, industryB: action.industryB };
    case SET_INDUSTRY_N:
      return { ...state, industryN: action.industryN };
    case SET_INDUSTRY_S:
      return { ...state, industryS: action.industryS };
    case SET_INDUSTRY_M:
      return { ...state, industryM: action.industryM };
    case SET_PRODUCT_SEARCH_CONDITION:
      return { ...state, searchProductCondition: action.searchProductCondition };
    case SET_BUSINESS_TYPE:
      return { ...state, businessType: action.businessType };
    case SET_TRADE_INFO_SEARCH_ITEM_LIST:
      return { ...state, tradeInfoSearchItemList: action.tradeInfoSearchItemList };
    case SET_TARGET_LIST_HEADER_ITEM:
      return { ...state, targetListHeaderItem: action.targetListHeaderItem };
    case SET_TARGET_LIST_HEADER_WIDTH:
      return { ...state, targetListHeaderWidth: action.targetListHeaderWidth };
    case SET_TARGET_LIST_CATEGORY:
      return { ...state, targetListCategory: action.targetListCategory };
    case SET_SAVE_CONDITON_POP_FLG:
      return { ...state, saveConditionPopFlg: action.saveConditionPopFlg };
    case SET_SAVE_CONDITON_SUCCESS_POP_FLG:
      return { ...state, saveConditionSuccessPopFlg: action.saveConditionSuccessPopFlg };
    case SET_SEARCH_CONDITON_POP_FLG:
      return { ...state, searchConditionPopFlg: action.searchConditionPopFlg };
    case SET_SEARCH_CONDITON_DELETE_POP_FLG:
      return { ...state, searchConditionDeletePopFlg: action.searchConditionDeletePopFlg };
    case SET_ALERT_MASTER_POP_FLG:
      return { ...state, alertMasterPopFlg: action.alertMasterPopFlg };
    case SET_ADDRESS_POP_FLG:
      return { ...state, addressPopFlg: action.addressPopFlg };
    case SET_INDUSTRY_POP_FLG:
      return { ...state, industryPopFlg: action.industryPopFlg };
    case SET_PRODUCTS_POP_FLG:
      return { ...state, productsPopFlg: action.productsPopFlg };
    case SET_TRADE_INFO_POP_FLG:
      return { ...state, tradeInfoPopFlg: action.tradeInfoPopFlg };
    case SET_COMPANY_POP_FLG:
      return { ...state, companyPopFlg: action.companyPopFlg };
    case SET_COMPANY_POP_BTN:
      return { ...state, companyPopBtn: action.companyPopBtn };
    case SET_DOWNLOAD_REQUEST_POP_FLG:
      return {
        ...state,
        downloadRequestPopFlg: action.downloadRequestPopFlg,
        downloadLimitOverFlg: action.downloadLimitOverFlg,
        downloadLimitOverMessage: action.downloadLimitOverMessage,
      };
    case SET_DOWNLOAD_CONFIG:
      return { ...state, downloadConfig: action.downloadConfig };
    case SET_NOWPAGE:
      return { ...state, nowpage: action.nowpage };
    case SET_SEARCH_CONDITON_SEQ_ID:
      return { ...state, searchConditionSeqId: action.searchConditionSeqId };
    case SET_SEARCH_CONDITION_LIST:
      return { ...state, searchConditionList: action.searchConditionList };
    case SET_IMPORT_FILE:
      return { ...state, importFile: action.importFile };
    case SET_ALERT_ITEM:
      return { ...state, alertItem: action.alertItem };
    // -------------------- salesforce連携、外部連携 ここから --------------------
    case SET_SEND_SALESFORCE_POP_FLG:
      return { ...state, sendSalesforcePopFlg: action.sendSalesforcePopFlg };
    case SET_SEND_SALESFORCE_TARGET_NAME:
      return { ...state, sendSalesforceTargetName: action.sendSalesforceTargetName };
    case SET_SEND_EXTERNAL_POP_FLG:
      return { ...state, sendExternalPopFlg: action.sendExternalPopFlg };
    case SET_SEND_EXTERNAL_CONFIG:
      return { ...state, sendExternalConfig: action.sendExternalConfig };
    case SET_SEND_EXTERNAL_TARGET_NAME:
      return { ...state, sendExternalTargetName: action.sendExternalTargetName };
    case SET_SEND_EXTERNAL_RESULT_POP_FLG:
      return {
        ...state,
        sendExternalResultPopFlg: action.sendExternalResultPopFlg,
        sendExternalLimitOverFlg: action.sendExternalLimitOverFlg,
      };
    case SET_SALESFORCE_MAP_OBJECT:
      return { ...state, salesforceMapObject: action.salesforceMapObject };
    case SET_SALESFORCE_MAP_OBJECT_NAME:
      return { ...state, salesforceMapObjectName: action.salesforceMapObjectName };
    case SET_SALESFORCE_MAP_MODE_KBN:
      return { ...state, salesforceMapModeKbn: action.salesforceMapModeKbn };
    case SET_SALESFORCE_MAP_COLUMN_NAME:
      return { ...state, salesforceMapColumnName: action.salesforceMapColumnName };
    case SET_SALESFORCE_MAP_FIELD_LIST:
      return { ...state, salesforceMapFieldList: action.salesforceMapFieldList };
    case SET_SALESFORCE_MAX_CHECK_COUNT:
      return { ...state, salesforceMaxCheckCount: action.salesforceMaxCheckCount };
    case SET_EXTERNAL_MAX_CHECK_COUNT:
      return { ...state, externalMaxCheckCount: action.externalMaxCheckCount };
    case SET_EXTERNAL_ERR_MSG:
      return { ...state, externalErrMsg: action.externalErrMsg };
    // -------------------- salesforce連携、外部連携 ここまで --------------------
    // -------------------- 検索条件 ここから --------------------
    case SET_SEARCH_TARGET:
      return { ...state, searchTarget: action.searchTarget };
    case SET_SELECT_AREA:
      return { ...state, selectArea: action.selectArea };
    case SET_SELECT_PREF:
      return { ...state, selectPref: action.selectPref };
    case SET_ADDRESS_CONDITION:
      return { ...state, addressCondition: action.addressCondition };
    case SET_SELECT_INDUSTRY_B:
      return { ...state, selectIndustryB: action.selectIndustryB };
    case SET_SELECT_INDUSTRY_N:
      return { ...state, selectIndustryN: action.selectIndustryN };
    case SET_SELECT_INDUSTRY_S:
      return { ...state, selectIndustryS: action.selectIndustryS };
    case SET_SELECT_INDUSTRY_M:
      return { ...state, selectIndustryM: action.selectIndustryM };
    case SET_INDUSTRY_CONDITION:
      return { ...state, industryCondition: action.industryCondition };
    case SET_PRODUCTS_CONDITION:
      return { ...state, productsCondition: action.productsCondition };
    case SET_CUSTOMER_COMPANY_CONDITION:
      return { ...state, customerCompanyCondition: action.customerCompanyCondition };
    case SET_SUPPLIER_COMPANY_CONDITION:
      return { ...state, supplierCompanyCondition: action.supplierCompanyCondition };
    case SET_TOP_COMPANY_CONDITION:
      return { ...state, topCompanyCondition: action.topCompanyCondition };
    case SET_MAIN_INDUSTRY_FLG:
      return { ...state, mainIndustryFlg: action.mainIndustryFlg };
    case SET_TRADE_INFO_SEARCH_ITEM:
      return { ...state, tradeInfoSearchItem: action.tradeInfoSearchItem };
    case SET_TRADE_INFO_CONDITION:
      return { ...state, tradeInfoCondition: action.tradeInfoCondition };
    case SET_ACCOUNT_MONTH:
      return { ...state, accountMonth: action.accountMonth };
    case SET_CAPITAL_FROM:
      return { ...state, capitalFrom: action.capitalFrom };
    case SET_CAPITAL_TO:
      return { ...state, capitalTo: action.capitalTo };
    case SET_SALES_FROM:
      return { ...state, salesFrom: action.salesFrom };
    case SET_SALES_TO:
      return { ...state, salesTo: action.salesTo };
    case SET_LATEST_FLG:
      return { ...state, latestFlg: action.latestFlg };
    case SET_SALES_RATE_FROM:
      return { ...state, salesRateFrom: action.salesRateFrom };
    case SET_SALES_RATE_TO:
      return { ...state, salesRateTo: action.salesRateTo };
    case SET_BENEFIT_FROM:
      return { ...state, benefitFrom: action.benefitFrom };
    case SET_BENEFIT_TO:
      return { ...state, benefitTo: action.benefitTo };
    case SET_BENEFIT_RATE_FROM:
      return { ...state, benefitRateFrom: action.benefitRateFrom };
    case SET_BENEFIT_RATE_TO:
      return { ...state, benefitRateTo: action.benefitRateTo };
    case SET_EMPLOYEE_FROM:
      return { ...state, employeeFrom: action.employeeFrom };
    case SET_EMPLOYEE_TO:
      return { ...state, employeeTo: action.employeeTo };
    case SET_TOP_DUNS:
      return { ...state, topDuns: action.topDuns };
    case SET_TOP_TSR_CODE:
      return { ...state, topTsrCode: action.topTsrCode };
    case SET_SCORE_FROM:
      return { ...state, scoreFrom: action.scoreFrom };
    case SET_SCORE_TO:
      return { ...state, scoreTo: action.scoreTo };
    case SET_OFFICE_COUNT_FROM:
      return { ...state, officeCountFrom: action.officeCountFrom };
    case SET_OFFICE_COUNT_TO:
      return { ...state, officeCountTo: action.officeCountTo };
    case SET_REP_LAST_NAME:
      return { ...state, repLastName: action.repLastName };
    case SET_REP_FIRST_NAME:
      return { ...state, repFirstName: action.repFirstName };
    case SET_ADDITIONALITEM:
      return { ...state, additionalitem: action.additionalitem };
    case SET_TRADE_SEARCH_FLAG1:
      return { ...state, tradesearchflag1: action.tradesearchflag1 };
    case SET_TRADE_SEARCH_FLAG2:
      return { ...state, tradesearchflag2: action.tradesearchflag2 };
    case SET_DISP_CAPITAL_FROM:
      return { ...state, dispCapitalFrom: action.dispCapitalFrom };
    case SET_DISP_CAPITAL_TO:
      return { ...state, dispCapitalTo: action.dispCapitalTo };
    case SET_DISP_SALES_FROM:
      return { ...state, dispSalesFrom: action.dispSalesFrom };
    case SET_DISP_SALES_TO:
      return { ...state, dispSalesTo: action.dispSalesTo };
    case SET_DISP_SALES_RATE_FROM:
      return { ...state, dispSalesRateFrom: action.dispSalesRateFrom };
    case SET_DISP_SALES_RATE_TO:
      return { ...state, dispSalesRateTo: action.dispSalesRateTo };
    case SET_DISP_BENEFIT_FROM:
      return { ...state, dispBenefitFrom: action.dispBenefitFrom };
    case SET_DISP_BENEFIT_TO:
      return { ...state, dispBenefitTo: action.dispBenefitTo };
    case SET_DISP_BENEFIT_RATE_FROM:
      return { ...state, dispBenefitRateFrom: action.dispBenefitRateFrom };
    case SET_DISP_BENEFIT_RATE_TO:
      return { ...state, dispBenefitRateTo: action.dispBenefitRateTo };
    case SET_DISP_EMPLOYEES_FROM:
      return { ...state, dispEmployeesFrom: action.dispEmployeesFrom };
    case SET_DISP_EMPLOYEES_TO:
      return { ...state, dispEmployeesTo: action.dispEmployeesTo };
    case SET_DISP_OFFICE_COUNT_FROM:
      return { ...state, dispOfficeCountFrom: action.dispOfficeCountFrom };
    case SET_DISP_OFFICE_COUNT_TO:
      return { ...state, dispOfficeCountTo: action.dispOfficeCountTo };
    case SET_SELECT_BUSINESS_TYPE:
      return { ...state, selectBusinessType: action.selectBusinessType };
    // -------------------- 検索条件 ここまで --------------------
    // -------------------- 検索条件 ポップアップ用 ここから --------------------
    case SET_INDUSTRY_ADD_CONDITION:
      return { ...state, industryAddCondition: action.industryAddCondition };
    case SET_INDUSTRY_DISPLAY_CONDITION:
      return { ...state, industryDisplayCondition: action.industryDisplayCondition };
    case SET_PRODUCT_DISPLAY_CONDITION:
      return { ...state, productDisplayCondition: action.productDisplayCondition };
    case SET_INDUSTRY_RESULT:
      return { ...state, industryResult: action.industryResult };
    case SET_INDUSTRY_KEYWORD:
      return { ...state, industryKeyword: action.industryKeyword };
    case SET_CONDITION_NAME:
      return { ...state, conditionName: action.conditionName };
    case SET_DISP_CONDITION_NAME:
      return { ...state, dispConditionName: action.dispConditionName };
    case SET_COMPANY_DUNS_KEYWORD:
      return { ...state, companyDunsKeyword: action.companyDunsKeyword };
    case SET_COMPANY_TSR_KEYWORD:
      return { ...state, companyTsrKeyword: action.companyTsrKeyword };
    case SET_COMPANY_NAME_KEYWORD:
      return { ...state, companyNameKeyword: action.companyNameKeyword };
    case SET_COMPANY_HOJIN_KEYWORD:
      return { ...state, companyHojinKeyword: action.companyHojinKeyword };
    case SET_COMPANY_NAME_SEARCH_TYPE:
      return { ...state, companyNameSearchType: action.companyNameSearchType };
    case SET_COMPANY_RESULT:
      return { ...state, companyResult: action.companyResult };
    case SET_CUSTOMER_COMPANY_ADD_CONDITION:
      return { ...state, customerCompanyAddCondition: action.customerCompanyAddCondition };
    case SET_CUSTOMER_COMPANY_DISPLAY_CONDITION:
      return { ...state, customerCompanyDisplayCondition: action.customerCompanyDisplayCondition };
    case SET_SUPPLIER_COMPANY_ADD_CONDITION:
      return { ...state, supplierCompanyAddCondition: action.supplierCompanyAddCondition };
    case SET_SUPPLIER_COMPANY_DISPLAY_CONDITION:
      return { ...state, supplierCompanyDisplayCondition: action.supplierCompanyDisplayCondition };
    case SET_TOP_COMPANY_ADD_CONDITION:
      return { ...state, topCompanyAddCondition: action.topCompanyAddCondition };
    case SET_TOP_COMPANY_DISPLAY_CONDITION:
      return { ...state, topCompanyDisplayCondition: action.topCompanyDisplayCondition };
    case SET_TRADE_INFO_ADD_CONDITION:
      return { ...state, tradeInfoAddCondition: action.tradeInfoAddCondition };
    case SET_ADDRESS_KEYWORD:
      return { ...state, addressKeyword: action.addressKeyword };
    case SET_ADDRESS_RESULT:
      return { ...state, addressResult: action.addressResult };
    case SET_ADDRESS_ADD_CONDITION:
      return { ...state, addressAddCondition: action.addressAddCondition };
    case SET_ADDRESS_DISPLAY_CONDITION:
      return { ...state, addressDisplayCondition: action.addressDisplayCondition };
    case SET_TARGETING_DISP_ITEMS:
      return { ...state, targetingDispItems: action.targetingDispItems };

    // -------------------- 検索条件 ポップアップ用 ここまで --------------------
    // -------------------- エラーメッセージ ここから --------------------
    case SET_ERR_MSG_CAPITAL:
      return { ...state, errMsgCapital: action.errMsgCapital };
    case SET_ERR_MSG_SALES:
      return { ...state, errMsgSales: action.errMsgSales };
    case SET_ERR_MSG_RATE:
      return { ...state, errMsgRate: action.errMsgRate };
    case SET_ERR_MSG_BENEFIT:
      return { ...state, errMsgBenefit: action.errMsgBenefit };
    case SET_ERR_MSG_BENEFIT_RATE:
      return { ...state, errMsgBenefitRate: action.errMsgBenefitRate };
    case SET_ERR_MSG_EMPLOYEES:
      return { ...state, errMsgEmployees: action.errMsgEmployees };
    case SET_ERR_MSG_TOP_TSR_CODE:
      return { ...state, errMsgTopTsrCode: action.errMsgTopTsrCode };
    case SET_ERR_MSG_TOP_DUNS:
      return { ...state, errMsgTopDuns: action.errMsgTopDuns };
    case SET_ERR_MSG_SCORE:
      return { ...state, errMsgScore: action.errMsgScore };
    case SET_ERR_MSG_OFFICE_COUNT:
      return { ...state, errMsgOfficeCount: action.errMsgOfficeCount };
    case SET_ERR_MSG_REP_NAME:
      return { ...state, errMsgRepName: action.errMsgRepName };
    case SET_ERR_MSG_TRADE_INFO_SEARCH_VALUE:
      return { ...state, errMsgTradeInfoSearchValue: action.errMsgTradeInfoSearchValue };
    case SET_ERR_MSG_TRADE_INFO_LIMIT:
      return { ...state, errMsgTradeInfoLimit: action.errMsgTradeInfoLimit };
    case SET_ERR_MSG_TRADE_INFO_REQUIRED:
      return { ...state, errMsgTradeInfoRequired: action.errMsgTradeInfoRequired };
    case SET_ERR_MSG_INDUSTRY_KEYWORD:
      return { ...state, errMsgIndustryKeyword: action.errMsgIndustryKeyword };
    case SET_ERR_MSG_INDUSTRY_DUPLICATE:
      return { ...state, errMsgIndustryDuplicate: action.errMsgIndustryDuplicate };
    case SET_ERR_MSG_COMPANY_DUNS_KEYWORD:
      return { ...state, errMsgCompanyDunsKeyword: action.errMsgCompanyDunsKeyword };
    case SET_ERR_MSG_COMPANY_TSR_KEYWORD:
      return { ...state, errMsgCompanyTsrKeyword: action.errMsgCompanyTsrKeyword };
    case SET_ERR_MSG_COMPANY_NAME_KEYWORD:
      return { ...state, errMsgCompanyNameKeyword: action.errMsgCompanyNameKeyword };
    case SET_ERR_MSG_COMPANY_HOJIN_KEYWORD:
      return { ...state, errMsgCompanyHojinKeyword: action.errMsgCompanyHojinKeyword };
    case SET_ERR_MSG_COMPANY_DUPLICATE:
      return { ...state, errMsgCompanyDuplicate: action.errMsgCompanyDuplicate };
    case SET_LIMIT_MESSAGE:
      return { ...state, limitMessage: action.limitMessage };
    case SET_ERR_MSG_PRODUCT_KEYWORD:
      return { ...state, errMsgProductKeyword: action.errMsgProductKeyword };
    case SET_ERR_MSG_PRODUCT_DUPLICATE:
      return { ...state, errMsgProductDuplicate: action.errMsgProductDuplicate };
    case SET_ERR_MSG_CONDITION_NAME:
      return { ...state, errMsgConditionName: action.errMsgConditionName };
    case SET_ERR_MSG_SEARCH_CONDITION_POP:
      return { ...state, errMsgSearchConditionPop: action.errMsgSearchConditionPop };
    case SET_ERR_MSG_SGKN:
      return { ...state, errMsgSgkn: action.errMsgSgkn };
    case SET_ERR_MSG_START_YM:
      return { ...state, errMsgStartYm: action.errMsgStartYm };
    case SET_ERR_MSG_SYRK_GKNY:
      return { ...state, errMsgSyrkGkny: action.errMsgSyrkGkny };
    case SET_ERR_MSG_ADDRESS_KEYWORD:
      return { ...state, errMsgAddressKeyword: action.errMsgAddressKeyword };
    case SET_ERR_MSG_ADDRESS_POP:
      return { ...state, errMsgAddressPop: action.errMsgAddressPop };
    case SET_ERR_MSG_EXTERNAL_TARGET_NAME:
      return { ...state, errMsgExternalTargetName: action.errMsgExternalTargetName };
    case SET_ERR_MSG_SALESFORCE_TARGET_NAME:
      return { ...state, errMsgSalesforceTargetName: action.errMsgSalesforceTargetName };
    // -------------------- エラーメッセージ ここまで --------------------
    // -------------------- エラーフラグ ここから --------------------
    case SET_CHECK_CAPITAL_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCapitalFrom: action.checkCapitalFrom,
        },
      };
    case SET_CHECK_CAPITAL_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCapitalTo: action.checkCapitalTo,
        },
      };
    case SET_CHECK_SALES_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkSalesFrom: action.checkSalesFrom,
        },
      };
    case SET_CHECK_SALES_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkSalesTo: action.checkSalesTo,
        },
      };
    case SET_CHECK_RATE_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkRateFrom: action.checkRateFrom,
        },
      };
    case SET_CHECK_RATE_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkRateTo: action.checkRateTo,
        },
      };
    case SET_CHECK_BENEFIT_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkBenefitFrom: action.checkBenefitFrom,
        },
      };
    case SET_CHECK_BENEFIT_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkBenefitTo: action.checkBenefitTo,
        },
      };
    case SET_CHECK_BENEFIT_RATE_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkBenefitRateFrom: action.checkBenefitRateFrom,
        },
      };
    case SET_CHECK_BENEFIT_RATE_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkBenefitRateTo: action.checkBenefitRateTo,
        },
      };
    case SET_CHECK_EMPLOYEES_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkEmployeesFrom: action.checkEmployeesFrom,
        },
      };
    case SET_CHECK_EMPLOYEES_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkEmployeesTo: action.checkEmployeesTo,
        },
      };
    case SET_CHECK_TOP_DUNS:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkTopDuns: action.checkTopDuns,
        },
      };
    case SET_CHECK_TOP_TSR_CODE:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkTopTsrCode: action.checkTopTsrCode,
        },
      };
    case SET_CHECK_SCORE_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkScoreFrom: action.checkScoreFrom,
        },
      };
    case SET_CHECK_SCORE_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkScoreTo: action.checkScoreTo,
        },
      };
    case SET_CHECK_OFFICE_COUNT_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkOfficeCountFrom: action.checkOfficeCountFrom,
        },
      };
    case SET_CHECK_OFFICE_COUNT_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkOfficeCountTo: action.checkOfficeCountTo,
        },
      };

    case SET_CHECK_REP_LAST_NAME:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkRepLastName: action.checkRepLastName,
        },
      };
    case SET_CHECK_REP_FIRST_NAME:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkRepFirstName: action.checkRepFirstName,
        },
      };
    case SET_CHECK_TRADE_INFO_SEARCH_VALUE:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkTradeInfoSearchValue: action.checkTradeInfoSearchValue,
        },
      };
    case SET_CHECK_TRADE_INFO_LIMIT:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkTradeInfoLimit: action.checkTradeInfoLimit,
        },
      };
    case SET_CHECK_INDUSTRY_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkIndustryKeyword: action.checkIndustryKeyword,
        },
      };
    case SET_CHECK_PRODUCT_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkProductKeyword: action.checkProductKeyword,
        },
      };
    case SET_CHECK_CONDITION_NAME:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkConditionName: action.checkConditionName,
        },
      };
    case SET_CHECK_COMPANY_DUNS_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCompanyDunsKeyword: action.checkCompanyDunsKeyword,
        },
      };
    case SET_CHECK_COMPANY_TSR_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCompanyTsrKeyword: action.checkCompanyTsrKeyword,
        },
      };
    case SET_CHECK_COMPANY_NAME_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCompanyNameKeyword: action.checkCompanyNameKeyword,
        },
      };
    case SET_CHECK_COMPANY_HOJIN_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkCompanyHojinKeyword: action.checkCompanyHojinKeyword,
        },
      };
    case SET_CHECK_SGKN:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkSgkn: action.checkSgkn,
        },
      };
    case SET_CHECK_START_YEAR_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkStartYearFrom: action.checkStartYearFrom,
        },
      };
    case SET_CHECK_START_MONTH_FROM:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkStartMonthFrom: action.checkStartMonthFrom,
        },
      };
    case SET_CHECK_START_YEAR_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkStartYearTo: action.checkStartYearTo,
        },
      };
    case SET_CHECK_START_MONTH_TO:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkStartMonthTo: action.checkStartMonthTo,
        },
      };
    case SET_CHECK_SYRK_GKNY:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkSyrkGkny: action.checkSyrkGkny,
        },
      };
    case SET_CHECK_ADDRESS_KEYWORD:
      return {
        ...state,
        checkErrFlg: {
          ...state.checkErrFlg,
          checkAddressKeyword: action.checkAddressKeyword,
        },
      };
    // -------------------- エラーフラグ ここまで --------------------
    case SET_INIT_SEARCH_CONDITION:
      // 検索条件クリアボタン押下時の処理
      return {
        ...state,
        // 地域、大分類以外の候補リストを初期化
        prefList: null,
        industryN: null,
        industryS: null,
        industryM: null,
        // 業種選択ポップアップの選択内容を初期化
        industryAddCondition: null,
        industryDisplayCondition: null,
        // 扱い品選択ポップアップの選択内容を初期化
        productAddCondition: null,
        productDisplayCondition: null,
        searchConditionDeletePopFlg: false,
        // 所在地選択ポップアップの選択内容を初期化
        addressAddCondition: null,
        addressDisplayCondition: null,
        // 販売先ポップアップの選択内容を初期化
        customerCompanyAddCondition: null,
        customerCompanyDisplayCondition: null,
        // 仕入先ポップアップの選択内容を初期化
        supplierCompanyAddCondition: null,
        supplierCompanyDisplayCondition: null,
        // 国内最上位親会社ポップアップの選択内容を初期化
        topCompanyAddCondition: null,
        topCompanyDisplayCondition: null,
        // 検索条件名を初期化
        dispConditionName: null,
        // 検索タブ用検索条件を初期化
        ...initDispSearchCondition,
        // 入力チェック用エラー情報を初期化
        ...initErrInfo,
      };

    case SET_UPDATE_TARGETING_CRITERIA:
      return {
        ...state,
        // 検索対象
        searchTarget: action.searchTarget,
        // 所在地追加済み条件
        addressCondition: action.addressCondition,
        // 所在地選択ポップアップの選択内容を初期化
        addressAddCondition: null,
        addressDisplayCondition: null,
        // 業種追加済み条件
        industryCondition: action.industryCondition,
        // 業種選択ポップアップの選択内容を初期化
        industryAddCondition: null,
        industryDisplayCondition: null,
        // 扱い品追加済み条件
        productsCondition: action.productsCondition,
        // 扱い品選択ポップアップの選択内容を初期化
        productAddCondition: null,
        productDisplayCondition: null,
        // 主業種フラグ
        mainIndustryFlg: action.mainIndustryFlg,
        // 取引情報追加済み条件
        tradeInfoCondition: action.tradeInfoCondition,
        // 最新決済月
        accountMonth: action.accountMonth,
        // 資本金
        capitalFrom: action.capitalFrom,
        capitalTo: action.capitalTo,
        // 当期売上高
        salesFrom: action.salesFrom,
        salesTo: action.salesTo,
        // 決算情報最新期フラグ
        latestFlg: action.latestFlg,
        // 当期売上伸長率
        salesRateFrom: action.salesRateFrom,
        salesRateTo: action.salesRateTo,
        // 当期利益金
        benefitFrom: action.benefitFrom,
        benefitTo: action.benefitTo,
        // 当期利益伸長率
        benefitRateFrom: action.benefitRateFrom,
        benefitRateTo: action.benefitRateTo,
        // 従業員数
        employeeFrom: action.employeeFrom,
        employeeTo: action.employeeTo,
        // 国内最上位親会社DUNS
        topDuns: action.topDuns,
        // 国内最上位親会社TSRコード
        topTsrCode: action.topTsrCode,
        // 評点
        scoreFrom: action.scoreFrom,
        scoreTo: action.scoreTo,
        // 事業所数
        officeCountFrom: action.officeCountFrom,
        officeCountTo: action.officeCountTo,
        // 代表者
        repLastName: action.repLastName,
        repFirstName: action.repFirstName,
        // 取引情報有無
        additionalitem: action.additionalitem,
        // 取引情報検索フラグ1
        tradesearchflag1: action.tradesearchflag1,
        // 取引情報検索フラグ2
        tradesearchflag2: action.tradesearchflag2,
        // 表示用資本金(3桁カンマ)
        dispCapitalFrom: action.dispCapitalFrom,
        dispCapitalTo: action.dispCapitalTo,
        // 表示用売上高(3桁カンマ)
        dispSalesFrom: action.dispSalesFrom,
        dispSalesTo: action.dispSalesTo,
        // 表示用売上高伸長率(3桁カンマ)
        dispSalesRateFrom: action.salesRateFrom,
        dispSalesRateTo: action.dispSalesRateTo,
        // 表示用利益金(3桁カンマ)
        dispBenefitFrom: action.dispBenefitFrom,
        dispBenefitTo: action.dispBenefitTo,
        // 表示用利益金伸長率(3桁カンマ)
        dispBenefitRateFrom: action.dispBenefitRateFrom,
        dispBenefitRateTo: action.dispBenefitRateTo,
        // 表示用従業員数(3桁カンマ)
        dispEmployeesFrom: action.dispEmployeesFrom,
        dispEmployeesTo: action.dispEmployeesTo,
        // 表示用事業所数(3桁カンマ)
        dispOfficeCountFrom: action.dispOfficeCountFrom,
        dispOfficeCountTo: action.dispOfficeCountTo,
        // 事業所区分リスト
        jgkbList: action.jgkbList,
        // 上場市場リスト
        marketSegment: action.marketSegment,
        // 商号漢字
        sgkn: action.sgkn,
        // 商号漢字検索タイプ区分
        sgknSearchType: action.sgknSearchType,
        // 設立年FROM
        startYearFrom: action.startYearFrom,
        // 設立月FROM
        startMonthFrom: action.startMonthFrom,
        // 設立年TO
        startYearTo: action.startYearTo,
        // 設立月TO
        startMonthTo: action.startMonthTo,
        // 概況
        syrkGkny: action.syrkGkny,
        // 販売先
        customerCompanyCondition: action.customerCompanyCondition,
        // 仕入先
        supplierCompanyCondition: action.supplierCompanyCondition,
        // 国内最上位親会社
        topCompanyCondition: action.topCompanyCondition,
        // 格付け
        classificationList: action.classificationList,
      };
    case SET_SAVE_CONDITION:
      return { ...state, saveCondition: action.saveCondition };
    case SET_INIT_TARGET_STATE:
      return { ...initState };
    case SET_PRODUCT_RESULT_LIST:
      return { ...state, productResultList: action.productResultList };
    case SET_PRODUCT_ADD_CONDITION:
      return { ...state, productAddCondition: action.productAddCondition };
    case SET_SELECT_CONDITION_FLG:
      return { ...state, selectConditionFlg: action.selectConditionFlg };
    case SET_GET_ADDRESS_FLG:
      return { ...state, getAddressFlg: action.getAddressFlg };
    case SET_GET_INDUSTRY_FLG:
      return { ...state, getIndustryFlg: action.getIndustryFlg };
    case SET_GET_PRODUCT_FLG:
      return { ...state, getProductFlg: action.getProductFlg };
    case SET_GET_CUSTOMER_COMPANY_FLG:
      return { ...state, getCustomerCompanyFlg: action.getCustomerCompanyFlg };
    case SET_GET_SUPPLIER_COMPANY_FLG:
      return { ...state, getSupplierCompanyFlg: action.getSupplierCompanyFlg };
    case SET_GET_TOP_COMPANY_FLG:
      return { ...state, getTopCompanyFlg: action.getTopCompanyFlg };
    case SET_GET_TRADE_INFO_FLG:
      return { ...state, getTradeInfoFlg: action.getTradeInfoFlg };
    case SET_SCORE_SLIDER:
      return { ...state, scoreSlider: action.scoreSlider };
    case SET_CLASSIFICATION_LIST:
      return { ...state, classificationList: action.classificationList };
    case SET_SGKN:
      return { ...state, sgkn: action.sgkn };
    case SET_SGKN_SEARCH_TYPE:
      return { ...state, sgknSearchType: action.sgknSearchType };
    case SET_START_YEAR_FROM:
      return { ...state, startYearFrom: action.startYearFrom };
    case SET_START_MONTH_FROM:
      return { ...state, startMonthFrom: action.startMonthFrom };
    case SET_START_YEAR_TO:
      return { ...state, startYearTo: action.startYearTo };
    case SET_START_MONTH_TO:
      return { ...state, startMonthTo: action.startMonthTo };
    case SET_MARKET_SEGMENT:
      return { ...state, marketSegment: action.marketSegment };
    case SET_SYRK_GKNY:
      return { ...state, syrkGkny: action.syrkGkny };
    case SET_MARKET_SEGMENT_LIST:
      return { ...state, marketSegmentList: action.marketSegmentList };
    case SET_DISP_JGKB_LIST:
      return { ...state, dispJgkbList: action.dispJgkbList };
    case SET_JGKB_LIST:
      return { ...state, jgkbList: action.jgkbList };
    default:
      return state;
  }
};
